import { USE_CACHE } from '../common/config';
import { buildModel } from '../common/model';

/* Cache */
let Cache = function () {
  this.cache = {};
  this.reset = function () {
    this.cache = {};
  };
  this.cleanup = function () {

    let cacheMinutes = 1;
    let cacheSize = 32;
    let oldestTime = new Date().getTime() - (1000 * 60 * cacheMinutes);

    let elements = [];
    for (let element in this.cache) {
      if (this.cache[element].time < oldestTime) {
        delete this.cache[element];
      } else {
        elements.push(element);
      }
    }
    let c = this.cache;
    elements.sort(function (a, b) {
      return (c[a].time - c[b].time);
    });
    if (elements.length >= cacheSize) {
      for (let i = 0; i < elements.length - cacheSize; i++) {
        delete this.cache[elements[i]];
      }
    }
  };
};

let cache = new Cache();
window.CACHE = cache;

export function loadWithCache($http, $q) {
  return function (path, params, canceler, resetCache) {
    let requestHash = path + (params ? '?' + $.param(params) : '');
    cache.cleanup();
    if (USE_CACHE && !resetCache && (requestHash in cache.cache)) {
      let timediff = Math.round((new Date().getTime() -
        cache.cache[requestHash].time) / 1000 / 60);
      let result = cache.cache[requestHash].data;
      return $q.when(result);
    }
    let req_params = {};
    if (canceler) {
      req_params['timeout'] = canceler.promise;
    }
    if (params) {
      req_params.params = params;
    }
    return $http.get(path, req_params)
      .then(({data, status, headers, config}) => {
        let model = data;
        cache.cache[requestHash] = {
          'time': new Date().getTime(),
          'data': model,
        };
        return model;
      });
  };
}



// WEBPACK FOOTER //
// ./src/core/cache.service.js